/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_DistinctInputs */

const en_landing_pricing_compare_distinct = /** @type {(inputs: Landing_Pricing_Compare_DistinctInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One listing per website`)
};

const zh_landing_pricing_compare_distinct = /** @type {(inputs: Landing_Pricing_Compare_DistinctInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个网站仅一条收录`)
};

/**
* | output |
* | --- |
* | "One listing per website" |
*
* @param {Landing_Pricing_Compare_DistinctInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_distinct = /** @type {((inputs?: Landing_Pricing_Compare_DistinctInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_DistinctInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_distinct(inputs)
	return zh_landing_pricing_compare_distinct(inputs)
});
export { landing_pricing_compare_distinct as "landing.pricing.compare_distinct" }